import { Currency, ProductPriceMap } from 'prices/types'
import ProductPrices from '../product_prices.json'
import { PriceManager } from 'prices'
import { ShopStoreData } from 'stores/shop-store'
import * as productCatalog from './allProducts'
import { getSleepElixirVisuals } from 'shop/visualData/sleepElixirVisuals'

const priceManager: PriceManager = new PriceManager(ProductPrices as ProductPriceMap)

export class ProductDataManager {
	static getSleepElixirProductData(currency: Currency): ShopStoreData {
		const product = productCatalog.SupplementProducts.SleepElixir
		return {
			handle: product.handle,
			productTitle: product.name,
			productDescription: product.description.join(''),
			productId: product.id,
			selectedVariant: 'monthly',
			variants: Object.keys(product.variants)
				.filter((variantKey) => variantKey !== 'onetime')
				.map((variantKey) => {
					const variant = product.variants[variantKey]
					const variantPrices = priceManager.getFormattedVariantPrices(variant.id, currency)
					return {
						key: variantKey,
						id: variant.id,
						name: variant.name,
						...variantPrices,
						...(variantKey === 'monthly'
							? {
									saveText: 'Save 25%',
									badge: 'Best value',
									checklist: ['Save 25%', 'Pause or cancel any time'],
							  }
							: {}),
					}
				}),
			tabs: [
				{
					title: 'Details',
					content: 'Sleep Elixir helps you ease into sleep, faster, by leveraging over 600 million hours of sleep data and 100% natural ingredients.<br/><br/>60 capsules per container',
				},
				{
					title: 'Ingredients',
					content:
						'Sleep Elixir’s primary ingredients are 100% natural and include Valerian Root Extract, Ashwagandha, Tart Cherry, and L-Tryptophan. Other ingredients include Hypromellose, Microcrystalline Cellulose, Stearic Acid, and Silica. No melatonin, heavy metals, sugar or artificial sweeteners. ',
				},
				{
					title: 'How to use',
					content: 'Take 1–3 capsules, 60 minutes before bed every night, to prepare your body for optimal rest. Sleep Elixir is designed for nightly performance and is non-habit forming. ',
				},
				{
					title: 'Benefits',
					content:
						'Sleep Elixir helps you fall asleep faster, powered by over 600 million hours of sleep data and 100% natural ingredients. Designed to support your natural sleep cycles without dependency, 34% of users report falling asleep faster.*',
				},
			],
			features: [
				{ title: 'getShippingText', description: '', icon: 'DeliveryLight' },
				{ title: 'Free shipping', description: 'Whether you delay or fast-track your shipment', icon: 'EightBoxLight' },
				{ title: 'Cancel any time', description: 'Easily change your delivery date or pause anytime', icon: 'ClockLight', variant_key: 'monthly' },
			],
			visuals: getSleepElixirVisuals(),
		}
	}
}
